<template>
    <CompassFormItem
        :label="localizedTexts.date"
        orientation="horizontal"
        size="small"
        class="panel-create-activity__form-date"
    >
        <CompassDatePicker
            :modelValue="dateInput"
            :calendarOptions="{
                lang: uiLang,
                disableWeekDays: disabledWeekDays,
                disablePast: !isDone,
                maxDate: maxDate,
            }"
            :formatDateDisplayed="formatDateDisplayed"
            datePickerClass="panel-create-activity__datepicker"
            writable
            class="input-select-date-activity"
            @update:modelValue="onUpdateDateInput"
        />
        <CompassTimePicker
            v-model="timeInput"
            :hourFormat="hourformat"
            class="input-time-activity"
            :min="minTime"
            :max="maxTime"
            autoScroll
            @update:modelValue="onUpdateTimeInput"
        />
    </CompassFormItem>
</template>

<script>
import ActivityFormPanelDate from 'vcomponents/activities/activitiesFormPanel/ActivityFormPanelDate.vue';

export default {
    extends: ActivityFormPanelDate,
    props: {
        isDone: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            dateInput: '',
            timeInput: '',
            minTime: '',
            maxTime: '',
            maxDate: '',
        };
    },
    created() {
        this.resetMinMaxTime();
        if (this.activityData) {
            this.dateInput = moment(this.activityData.date).format('YYYY-MM-DD');
            this.timeInput = moment(this.activityData.date).format(this.momentTimeFormat);
            if (this.isDone) {
                if (moment(this.activityData.date).isAfter(moment())) {
                    this.dateInput = moment().format('YYYY-MM-DD');
                }
                this.timeInput = moment(this.timeInput, this.momentTimeFormat).isBefore(moment())
                    ? this.timeInput
                    : this.formatTimeInput(moment());
            }
        } else {
            this.timeInput = this.isDone
                ? this.getCurrentTime()
                : moment(this.workingHours.end_time, this.momentTimeFormat).format(
                      this.momentTimeFormat,
                  );
            this.dateInput = moment().isAfter(
                moment(this.workingHours.end_time, this.momentTimeFormat),
            )
                ? this.getNextWorkingDay()
                : moment().format('YYYY-MM-DD');
        }
        if (!this.isDone) {
            const momentActivityDate = moment(this.dateInput);
            if (!momentActivityDate || momentActivityDate.isSameOrBefore(moment(), 'day')) {
                this.dateInput = moment().format('YYYY-MM-DD');
                this.minTime = this.formatTimeInput(moment());
                if (moment(this.timeInput, this.momentTimeFormat).isBefore(moment())) {
                    this.timeInput = this.minTime;
                }
            }
        } else {
            this.maxDate = moment().format('YYYY-MM-DD');
            this.maxTime =
                moment(this.dateInput).isSameOrBefore(moment(), 'day') &&
                this.activityData &&
                moment().isAfter(moment(this.workingHours.end_time, this.momentTimeFormat))
                    ? this.workingTimeEnd
                    : this.formatTimeInput(moment());

            if (moment().isAfter(moment(this.workingHours.end_time, this.momentTimeFormat))) {
                this.maxTime = this.workingTimeEnd;
            }
        }

        if (
            !moment(this.minTime, this.momentTimeFormat).isBetween(
                moment(this.workingTimeStart, this.momentTimeFormat),
                moment(this.workingTimeEnd, this.momentTimeFormat),
            )
        ) {
            this.resetMinMaxTime();
        }
        this.updateDate();
    },
    methods: {
        resetMinMaxTime() {
            if (this.workingTimeStart) {
                this.minTime = this.workingTimeStart;
            }
            if (this.workingTimeEnd) {
                this.maxTime = this.workingTimeEnd;
            }
        },
        formatTimeInput(time) {
            const rest = time.format('mm') % this.MINUTES_INTERVAL;
            const maxRest = this.isDone ? 4 : 1;
            if (rest < maxRest) {
                time.subtract(rest, 'minutes').calendar();
            } else {
                time.add(this.MINUTES_INTERVAL - rest, 'minutes').calendar();
            }
            return time.format('HH:mm');
        },
        onUpdateDateInput(value) {
            this.resetMinMaxTime();
            if (!this.isDone && moment(value).isBefore(moment())) {
                this.timeInput = this.formatTimeInput(moment());
                this.minTime = this.timeInput;
            } else {
                if (moment(value).isBefore(moment(), 'day')) {
                    this.maxTime = this.formatTimeInput(moment());
                    this.timeInput = this.timeInput ?? this.workingTimeStart;
                }
            }
            this.dateInput = value;
            this.updateDate();
        },
        updateDate() {
            const timeMoment = moment(this.timeInput, this.momentTimeFormat);

            const date = moment(this.dateInput);
            date.set('hours', timeMoment.hours());
            date.set('minutes', timeMoment.minutes());

            this.$emit('update:activityDate', date.toISOString(true));
        },
        onUpdateTimeInput(value) {
            this.timeInput = value;
            this.updateDate();
        },
    },
};
</script>

<style scoped lang="scss">
.panel-create-activity__form-date {
    :deep(.compass-form-item__input) {
        flex-direction: row;
        gap: var(--spacing-3);
        .input-time-activity {
            width: 110px;
        }
        .input-select-date-activity .compass-input {
            width: 150px;
        }
    }
}
</style>
